import './index.css';
import { useEffect, useState } from 'react';
import { getWatchPartyById } from '../../../services/watchService';
import WatchpartyCard from './watchpartyCard';
import useAllWatchPage from '../../../hooks/useAllWatchPage';

const WatchpartyPage = () => {
  const {
    watchparties,
    error,
    showModal,
    partyName,
    isPublic,
    setPartyName,
    setIsPublic,
    setShowModal,
    fetchWatchparties,
    handleJoin,
    handleStartParty,
  } = useAllWatchPage();

  const [privateCode, setPrivateCode] = useState('');
  const [privateError, setPrivateError] = useState('');
  const [roomCode] = useState('');

  useEffect(() => {
    fetchWatchparties();

    const handleRefresh = () => {
      fetchWatchparties();
    };

    window.addEventListener('watchparty:created', handleRefresh);

    return () => {
      window.removeEventListener('watchparty:created', handleRefresh);
    };
  }, [fetchWatchparties]);

  const handlePrivateJoin = async () => {
    try {
      const data = await getWatchPartyById(privateCode.trim());
      if (!data) {
        setPrivateError('No watchparty found with that code.');
        return;
      }
      if (data.isPublic) {
        setPrivateError('This is a public watchparty. Please join it from the list.');
        return;
      }
      setPrivateError('');
      handleJoin(data._id.toString());
    } catch (err) {
      setPrivateError('No watchparty found with that code.');
    }
  };

  const handleCreateParty = async () => {
    await handleStartParty({
      customCode: isPublic ? undefined : roomCode.trim() || undefined,
    });
  };

  return (
    <div className='watchparty-page'>
      <h1>Live Watchparties</h1>
      {error && <div className='watchparty-error'>{error}</div>}

      <div className='watchparty-controls'>
        <button className='btn-watchparty' onClick={fetchWatchparties}>
          Refresh List
        </button>
        <button className='btn-watchparty' onClick={() => setShowModal(true)}>
          Start Watchparty
        </button>
      </div>

      {showModal && (
        <div className='watchparty-modal'>
          <div className='modal-content'>
            <h2>Start a New Watchparty</h2>
            <input
              type='text'
              placeholder='Enter party title'
              value={partyName}
              onChange={e => setPartyName(e.target.value)}
              className='input-party-title'
            />
            <div className='toggle-container'>
              <label className='toggle-label'>
                <input type='checkbox' checked={isPublic} onChange={() => setIsPublic(!isPublic)} />
                <span className='toggle-slider' />
                Public
              </label>
            </div>

            <div className='modal-buttons'>
              <button className='btn-cancel' onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button
                className='btn-submit'
                onClick={handleCreateParty}
                disabled={!partyName.trim()}>
                Start Party
              </button>
            </div>
          </div>
        </div>
      )}

      <div className='watchparty-grid'>
        {watchparties.length === 0 && <p>No live watchparties right now.</p>}
        {/* if private or over, don't render it */}
        {watchparties
          .filter(party => party.isPublic && !party.isOver)
          .map(party => (
            <WatchpartyCard key={party._id.toString()} party={party} onJoin={handleJoin} />
          ))}
      </div>

      <div className='private-party-section'>
        <h2 className='section-heading'>Join a Private Watchparty</h2>
        <div className='private-join-form'>
          <label htmlFor='private-code' className='private-label'>
            Enter Code:
          </label>
          <input
            id='private-code'
            type='text'
            className='private-code-input'
            placeholder='Enter code here...'
            value={privateCode}
            onChange={e => {
              setPrivateCode(e.target.value);
              setPrivateError('');
            }}
          />
          <button
            className='btn-watchparty'
            onClick={handlePrivateJoin}
            disabled={!privateCode.trim()}>
            Join
          </button>
        </div>
        {privateError && <p className='private-error'>{privateError}</p>}
      </div>
    </div>
  );
};

export default WatchpartyPage;
